export const GUEST_LOADING = "src/Guest/GUEST_LOADING";
export const GUEST_ERROR = "src/Guest/GUEST_ERROR";
export const SET_GUESTS = "src/Guest/SET_GUESTS";
